import { 
  Palette, 
  Monitor, 
  Smartphone, 
  Printer, 
  TrendingUp, 
  Code,
  Users,
  Award,
  Target,
  Lightbulb
} from 'lucide-react';

import leadImage from '../assets/img/lead.png';
import t1 from '../assets/img/MY.png';
import t2 from '../assets/img/t2.png';
import t3 from '../assets/img/t1.png';
import t4 from '../assets/img/t3.png';
import t5 from '../assets/img/t4.png';
import t6 from '../assets/img/t6.png';
import t7 from '../assets/img/t7.png';
import t8 from '../assets/img/t8.png';

import client1 from '../assets/pot/c1.png';
import client2 from '../assets/pot/c2.png';
import client3 from '../assets/pot/c3.png';
import client4 from '../assets/pot/c4.jpeg';
import client5 from '../assets/pot/c5.png';
import client6 from '../assets/pot/c6.png';
import client7 from '../assets/pot/c7.png'; 
import { id } from 'date-fns/locale';

//data of product    ========
// ----- S1 -----
import c11 from '../assets/pot/s1/1.png';
import c12 from '../assets/pot/s1/2.png';
import c13 from '../assets/pot/s1/3.png';
import c14 from '../assets/pot/s1/4.png';
import c15 from '../assets/pot/s1/5.png';
import c16 from '../assets/pot/s1/6.png';
import c17 from '../assets/pot/s1/7.png';
import c18 from '../assets/pot/s1/8.png';

// ----- S2 -----
import c21 from '../assets/pot/s2/1.png';
import c22 from '../assets/pot/s2/2.png';
import c23 from '../assets/pot/s2/3.png';
import c24 from '../assets/pot/s2/4.png';
import c25 from '../assets/pot/s2/5.png';
import c26 from '../assets/pot/s2/6.png';
import c27 from '../assets/pot/s2/7.png';

// ----- S3 -----
import c31 from '../assets/pot/s3/1.png';
import c32 from '../assets/pot/s3/2.png';
import c33 from '../assets/pot/s3/3.png';
import c34 from '../assets/pot/s3/4.png';
import c35 from '../assets/pot/s3/5.png';
import c36 from '../assets/pot/s3/6.png';
import c37 from '../assets/pot/s3/7.png';

// ----- S4 -----
import c41 from '../assets/pot/s4/1.png';
import c42 from '../assets/pot/s4/2.png';
import c43 from '../assets/pot/s4/3.png';
import c44 from '../assets/pot/s4/4.png';
import c45 from '../assets/pot/s4/5.png';
import c46 from '../assets/pot/s4/6.png';

// ----- S5 -----
import c51 from '../assets/pot/s5/1.png';
import c52 from '../assets/pot/s5/2.png';
import c53 from '../assets/pot/s5/3.png';
import c54 from '../assets/pot/s5/4.png';
import c55 from '../assets/pot/s5/5.png';
import c56 from '../assets/pot/s5/6.png';
import c57 from '../assets/pot/s5/7.png';
import c58 from '../assets/pot/s5/8.png';


// data End ==================

export const mockData = {
  // Company Stats
  stats: [
    { number: '10+', label: 'Creative Project' },
    { number: '7+', label: 'Brand Partner' },
    { number: '3+', label: 'Year Design Legacy' },
    // { number: '15+', label: 'Awards Won' }
  ],

  // Services
  services: [
    {
      title: 'Brand Identity',
      description: 'Complete brand identity design including logos, color palettes, typography, and brand guidelines that capture your essence.',
      icon: Palette,
      features: ['Logo Design', 'Brand Guidelines', 'Color Palette', 'Typography', 'Business Cards', 'Stationery']
    },
    {
      title: 'Print Design',
      description: 'Professional print materials that make lasting impressions, from business cards to large-format displays.',
      icon: Printer,
      features: ['Brochures', 'Flyers', 'Posters', 'Packaging', 'Annual Reports', 'Trade Show Materials']
    },
    {
      title: 'Web Design',
      description: 'Modern, responsive websites that convert visitors into customers with stunning visual design and seamless user experience.',
      icon: Monitor,
      features: ['Responsive Design', 'UI/UX Design', 'E-commerce', 'Landing Pages', 'CMS Development', 'SEO Optimization']
    },
    // {
    //   title: 'UI/UX Design',
    //   description: 'User-centered design approach creating intuitive interfaces that enhance user satisfaction and drive engagement.',
    //   icon: Smartphone,
    //   features: ['User Research', 'Wireframing', 'Prototyping', 'User Testing', 'Mobile Apps', 'Web Applications']
    // },
    // {
    //   title: 'Digital Marketing',
    //   description: 'Strategic digital marketing campaigns that boost brand awareness and drive measurable business results.',
    //   icon: TrendingUp,
    //   features: ['Social Media Design', 'Email Templates', 'Ad Campaigns', 'Content Strategy', 'Analytics', 'Campaign Management']
    // },
    {
      title: 'Web Development',
      description: 'Custom web development solutions that bring designs to life with clean code and optimal performance.',
      icon: Code,
      features: ['Frontend Development', 'Backend Development', 'CMS Integration', 'E-commerce Solutions', 'API Development', 'Maintenance']
    }
  ],

  // Portfolio Projects
  portfolio: [
    {
      id:'NS7EXCHANGE',
      title: 'NS7EXCHANGE',
      category: 'Brand Identity',
      intro: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      description: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      image: client1,
      images: [
        { src: c11, size: "large" },
        { src: c14, size: "large" },
        { src: c12, size: "half" },
        { src: c13, size: "half" },
        { src: c17, size: "large" },
        { src: c18, size: "large" },
      ],
      client: 'TechStart Inc.',
      year: '2025'
    },

    {
      id:'HelloChicks',
      title: 'Hello Chicks',
      category: 'Web Design',
      intro: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      description: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      image: client2,
      images: [
        { src: c21, size: "large" },
        { src: c22, size: "half" },
        { src: c23, size: "half" },
        { src: c24, size: "large" },
        { src: c25, size: "half" },
        { src: c26, size: "half" },
        { src: c27, size: "large" },
      ],
      client: 'TechStart Inc.',
      year: '2025'
    },

    {
      id:'RangrezRestaurant',
      title: 'Rangrez Restaurant',
      category: 'UI/UX Design',
      intro: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      description: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      image: client3,
      images: [
        { src: c31, size: "large" },
        { src: c32, size: "half" },
        { src: c33, size: "half" },
        { src: c34, size: "large" },
        { src: c35, size: "third" },
        { src: c36, size: "third" },
        { src: c37, size: "large" },
      ],
      client: 'TechStart Inc.',
      year: '2025'
    },
    {
      id:'RoseCosmetic',
      title: 'Rose Cosmetic',
      category: 'Web Design',
      intro: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      description: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      image: client4,
      images: [
        { src: c41, size: "large" },
        { src: c42, size: "half" },
        { src: c43, size: "half" },
        { src: c44, size: "large" },
        { src: c45, size: "half" },
        { src: c46, size: "half" },
      ],
      client: 'TechStart Inc.',
      year: '2025'
    },
    {
      id:'Caffevo',
      title: 'Caffevo',
      category: 'UI/UX Design',
      intro: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      description: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      image: client5,
      images: [
        { src: c51, size: "large" },
        { src: c52, size: "half" },
        { src: c53, size: "half" },
        { src: c54, size: "large" },
        { src: c56, size: "third" },
        { src: c58, size: "third" },
        // { src: c57, size: "third" },
        { src: c55, size: "large" },
      ],
      client: 'TechStart Inc.',
      year: '2025'
    },
    {
      id:'Eyemart',
      title: 'Eyemart',
      category: 'Brand Identity',
      intro: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      description: 'Complete rebrand for innovative tech startup including logo, website, and marketing materials.',
      image: client6,
      images: [
        { src: client6, size: "large" },
        { src: c52, size: "half" },
        { src: c58, size: "half" },
        { src: c54, size: "large" },
        { src: c55, size: "third" },
        { src: c56, size: "third" },
        { src: c51, size: "large" },
      ],
      client: 'TechStart Inc.',
      year: '2025'
    },
    // {
      // title: 'EventPro App Design',
      // category: 'UI/UX Design',
      // description: 'Comprehensive event management app with ticketing, scheduling, and networking features.',
      // image: client7,
      // client: 'EventPro Technologies',
      // year: '2024'
    // },
  ],

  
  // Team Members
  team: [
    {
      name: 'Niketan Sharma',
      position: 'Founder & CEO',
      bio: 'I’m Niketan Sharma,I blend creativity and strategy to turn ideas into visuals that connect with people and help brands grow. At NS7VISUALS, I focus on purposeful design, storytelling, and innovation, creating work that builds strong identities, inspires trust, and delivers real results.',
      image: leadImage,
      expertise: ['Areas of Interest','Brand Identity Design','Visual Storytelling','Creative Direction','Digital Innovation'],
      education: 'B.Sc In Animation & VFX',
      experience: '2+ Years',
      email: 'niketan@ns7visuals.com'
    },
    {
      name: 'Nitesh Chaubey',
      position: 'Creative Director',
      bio: 'Nitesh leads the creative direction at NS7VISUALS transforming ideas into visuals that inspire and perform. His approach blends innovation, design precision, and storytelling to ensure every project not only looks stunning but delivers real impact.',
      image: t2,
      expertise: ['User Research', 'Wireframing', 'Prototyping', 'Mobile Design'],
      education: 'MS in Human-Computer Interaction',
      experience: '7 Years'
    },
    {
      name: 'Priyanshu Pandey',
      position: 'CMO',
      bio: 'Priyanshu drives brand visibility and creative growth at NS7VISUALS. He bridges storytelling and strategy to build campaigns that connect deeply and convert effectively. His focus lies in turning creative ideas into measurable brand success.',
      image: t5,
      expertise: ['Frontend Development', 'Backend Development', 'CMS Development', 'Performance Optimization'],
      education: 'BS in Computer Science',
      experience: '8 Years'
    },
    {
      name: 'Walid Khan',
      position: 'Head of Strategy',
      bio: 'Walid shapes the long-term strategy that guides NS7VISUALS creative vision. He connects creativity with business intent, building frameworks that help brands grow with clarity, consistency, and purpose.',
      image: t3,
      expertise: ['Logo Design', 'Brand Strategy', 'Visual Identity', 'Print Design'],
      education: 'BFA in Graphic Design',
      experience: '6 Years'
    },
    {
      name: 'Md. Hussain Shaikh',
      position: 'Web Developer',
      bio: 'Hussain turns creative concepts into functional digital experiences. He bridges design and development to build fast, responsive, and scalable websites. His focus is on clean code, seamless performance, and delivering results that match NS7VISUALS creative standards.',
      image: t1,
      expertise: ['Frontend Development', 'Backend Development', 'CMS Development', 'Performance Optimization'],
      education: 'BS in Computer Science',
      experience: '8 Years'
    },
    {
      name: 'Simran Yadav',
      position: 'Business Development Associate',
      bio: 'Simran strengthens client relationships and drives business growth at NS7VISUALS. She works closely with the creative and strategy teams to align client goals with impactful digital solutions that deliver measurable value.',
      image: t4,
      expertise: ['Frontend Development', 'Backend Development', 'CMS Development', 'Performance Optimization'],
      education: 'BS in Computer Science',
      experience: '8 Years'
    },
    {
      name: 'Abhishek Nishad',
      position: 'Business Development Associate',
      bio: 'Abhishek focuses on expanding NS7VISUALS reach through strategic partnerships and client engagement. He blends communication, research, and relationship-building to create opportunities that support the studio’s creative and commercial growth.',
      image: t6,
      expertise: ['Frontend Development', 'Backend Development', 'CMS Development', 'Performance Optimization'],
      education: 'BS in Computer Science',
      experience: '8 Years'
    },
    {
      name: 'Reshma Vishwakarma',
      position: 'Graphic Designer',
      bio: 'Reshma turns ideas into compelling visual designs that bring stories to life. She combines creativity with precision to craft logos, layouts, and graphics that strengthen brand identity and communication across all platforms.',
      image: t7,
      expertise: ['Frontend Development', 'Backend Development', 'CMS Development', 'Performance Optimization'],
      education: 'BS in Computer Science',
      experience: '8 Years'
    },
    {
      name: ' Ashish Yadav',
      position: 'Video Editior',
      bio: 'Ashish brings motion to creativity, transforming raw footage into engaging visual stories. His expertise in pacing, transitions, and storytelling helps NS7VISUALS deliver videos that capture attention and leave a lasting impression.',
      image: t8,
      expertise: ['Frontend Development', 'Backend Development', 'CMS Development', 'Performance Optimization'],
      education: 'BS in Computer Science',
      experience: '8 Years'
    },
  ],

  // Testimonials
  testimonials: [
    {
      name: 'Niketan Sharma',
      position: 'Founder, NS7EXCHANGE',
      quote: 'NS7VISUALS gave our brand a sharp, credible identity that instantly increased customer trust and engagement. The redesign pushed NS7EXCHANGE toward real, measurable growth.',
      avatar: client1,
      company: 'NS7EXCHANGE',
      rating: 5
    },
    {
      name: 'Sandeep Vartha',
      position: 'CEO, Hello Chicks',
      quote: 'NS7VISUALS transformed our outdated look into a clean, professional identity. Customer recognition and trust improved immediately, helping Hello Chicks grow faster in the local market.',
      avatar: client2,
      company: 'Hello Chicks',
      rating: 5
    },
    {
      name: 'Ankit Vishwakarma',
      position: 'Founder, Rangrez',
      quote: 'I came across NS7VISUALS on Google while searching for branding help. Rangrez needed a premium look that matched our dining experience. They redesigned our identity and gave us a refined, upscale presence. Customers immediately noticed the upgrade and our reputation improved. This branding made our business stand out in a crowded hospitality space.',
      avatar: client3,
      company: 'Rangrez',
      rating: 5
    },
    {
      name: 'Riya Jain',
      position: 'Founder, Rose',
      quote: 'I discovered NS7VISUALS through one of their social media posts. My cosmetic brand didn’t look strong enough to compete in the beauty market. They rebuilt the entire identity into something clean, modern, and commercial. The new design increased customer interest and made the products look premium. Rose now feels like a brand ready for real retail-level growth.',
      avatar: client4,
      company: 'Rose',
      rating: 5
    }
  ],


  // Company Information
  company: {
    name: 'DesignCraft Agency',
    tagline: 'Crafting Exceptional Digital Experiences',
    description: 'We are a full-service design agency specializing in brand identity, web design, and digital marketing. Our team of creative professionals is dedicated to helping businesses stand out in today\'s competitive market.',
    mission: 'To empower businesses through exceptional design and creative solutions that drive growth and success.',
    values: [
      {
        title: 'Creativity',
        description: 'We push creative boundaries to deliver innovative solutions.',
        icon: Lightbulb
      },
      {
        title: 'Quality',
        description: 'Excellence in every project, no matter the size or scope.',
        icon: Award
      },
      {
        title: 'Collaboration',
        description: 'We work closely with clients to achieve shared goals.',
        icon: Users
      },
      {
        title: 'Results',
        description: 'Focused on delivering measurable business outcomes.',
        icon: Target
      }
    ],
    contact: {
      address: 'Mumbai, Maharashtra',
      phone: '+91 8698603964',
      email: 'contact@ns7visual.com',
      hours: 'Monday - Friday: 9:00 AM - 6:00 PM'
    }
  }
};